import { lazy } from "react";

import Login from "@features/Autenticacion/page/Login";
const WhiteZone = lazy(() => import("@components/WhiteZone"));

export const loginRoutes = {
    Component: Login,
    errorElement: <WhiteZone error />,
    path: "/",
};
